import React from "react";
import { fundingPaths } from "../../../routes/funding";
import { useNavigate } from "react-router-dom";

const ProjectSuccessModal = ({ onClose }) => {
  const navigate = useNavigate();

  return (
    <div
      className="modal d-block ct_congratulation_modal_fade ct_reactivate_account"
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered ct_modal-dialog">
        <div className="modal-content" style={{ borderRadius: "30px" }}>
          <div className="modal-body p-5">
            <div className="mx-auto d-block text-center mb-4">
              <svg
                width="80"
                height="80"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                  fill="#FFB703"
                />
              </svg>
            </div>
            <div className="text-center">
              <h4 className="ct_fs_20 ct_fw_500">Project Submitted </h4>
              <p className=" mx-auto" style={{ maxWidth: "298px" }}>
                Thanks for your submission. We'll review it and get back to you
                soon.{" "}
              </p>
            </div>

            <div class="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
              <button
                class=" ct_yellow_btn ct_outline_grey ct_h_48  px-5 ct_w_100_575"
                data-bs-dismiss="modal"
                onClick={() => {
                    navigate(fundingPaths.ExploreProject);
                    onClose();
                }}
              >
                Explore Project
              </button>
              <button
                class="ct_yellow_btn ct_h_48  px-5  ct_w_100_575"
                data-bs-dismiss="modal"
                onClick={onClose}
                type="button"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectSuccessModal;
